@if (isMobile) {
  <!--when in health plan or root-->
  @if (isHealthPlan || isRoot && !isActivityReport && hasActivePlan) {
    <button (click)="openSubMenu()" [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isHealthPlan || isRoot}"
      class="main-button"
      mat-fab>
      <mat-icon [ngClass]="{'rotate-close' : isSubMenuOpen, 'rotate-zero' : !isSubMenuOpen}" class="icon-color">add
      </mat-icon>
    </button>
  }
  <!--when in health plan activity new-->
  @if (isActivityReport && hasActivePlan) {
    <button (click)="saveAndGoBack()" [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isActivityReport}"
      class="main-button" mat-fab
      style="width: fit-content; border-radius: 20px;">
    <span style="padding: 5px 20px;
    display: inline-block;
    line-height: 24px;
    font-size: 20px;
    color: white;">{{ 'healthPlan.save' | translate }}</span>
    </button>
  }
  <!--when in diary -->
  @if (isDiary) {
    <button (click)="goToLocation('/new')"
      [attr.aria-label]="'diary.addNewMeasurement' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isDiary}"
      class="main-button yellow-outline"
      mat-fab>
      <mat-icon class="icon-color">add</mat-icon>
    </button>
  }
} @else {
  <!--when in health plan or root-->
  @if (isHealthPlan || isRoot && !isActivityReport && hasActivePlan) {
    <button
      (click)="openSubMenu()"
      [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [matTooltip]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isHealthPlan || isRoot}"
      class="desktop-main-button"
      mat-fab>
      <mat-icon [ngClass]="{'rotate-close' : isSubMenuOpen, 'rotate-zero' : !isSubMenuOpen}"
        class="icon-color">add
      </mat-icon>
    </button>
  }
  <!--when in health plan activity new-->
  @if (isActivityReport && hasActivePlan) {
    <button (click)="saveAndGoBack()"
      [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isActivityReport}"
      class="desktop-main-button"
      mat-fab
      style="width: fit-content; border-radius: 20px;">
      <span style="padding: 5px 20px;
    display: inline-block;
    line-height: 24px;
    font-size: 20px;
    color: white;">{{ 'healthPlan.save' | translate }}</span>
    </button>
  }
  <!--when in diary -->
  @if (isDiary) {
    <button
      (click)="goToLocation('/new')"
      [attr.aria-label]="'diary.addNewMeasurement' | translate"
      [matTooltip]="'diary.addNewMeasurement' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isDiary}"
      class="desktop-main-button yellow-outline"
      mat-fab>
      <mat-icon class="icon-color">add</mat-icon>
    </button>
  }
}




